import z from 'zod';

import { api } from 'common';
import { Flow } from 'vivaa-api';

export enum HumanTaskAppVariant {
  StaffApp = 'StaffApp',
  CopilotApp = 'CopilotApp',
}

export type HumanTask = api.Flow.HumanTask.HumanTask;

export const HumanTaskState = Flow.HumanTask.HumanTaskState;
export type HumanTaskState = Flow.HumanTask.HumanTaskState;

export const HumanTaskQueryParamsSchema = z
  .object({
    agentId: z.string(),
    flowId: z.string(),
    organizationId: z.string(),
    categoryId: z.array(z.string()),
    state: z.nativeEnum(api.Flow.HumanTask.HumanTaskState),
    createdByEmail: z.string(),
    searchTerm: z.string(),
    assignedToId: z.string().uuid(),
    q: z.string(),
    sortModel: z.array(
      z.object({
        field: z.string(),
        sort: z.nativeEnum(api.Common.SortOrder),
      })
    ),
  })
  .partial();
